/**
 * Created by JAVIER on 10/31/2019.
 */
import React from 'react'
import { Tooltip } from 'antd'

import './modalCarousel.css'

class SmallPhoto extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: false,
      shared: true,
      rotation: props.file.rotation || 0,
    }
  }

  handleOnClick = () => {
    this.props.onClick(this)
  }

  setHighlight = status => {
    this.setState({
      selected: status,
    })
  }

  setShare = (shared) => {
      this.setState({
          shared: shared
      })
  }

  setRotation = (rotation) => {
      this.setState({
          rotation: rotation
      })
  }

  handleOnDoubleClick = () => {
    this.props.onDoubleClick(this.props.file)
  }

  handleOnDragStart = e => {
    e.dataTransfer.dropEffect = 'copy'
    e.dataTransfer.setData(
      'data',
      JSON.stringify({ id: this.props.file._id, type: 'photo' })
    )
  }

  getImageUrl = () => {
    return this.props.shared ? `/api/v1/share/photos/image/small/${this.props.file._id}?token=${this.props.token}`
        : '/api/v1/photos/image/small/' + this.props.file._id;
  }

  render() {
    const comments = this.props.file.comments;
    this.state.shared = this.props.file.displayInSharedLink === 'true';
    return (
      <Tooltip title={comments}>
        <div
          className={'photo ' + (this.state.selected ? 'photo-border' :
              (this.state.shared ?  '' : 'photo-border-notshared') ) + ' rotate'+this.state.rotation}
          onClick={this.handleOnClick}
          onDoubleClick={this.handleOnDoubleClick}
        >
          <img
            src={this.getImageUrl()}
            draggable="true"
            onDragStart={this.handleOnDragStart}
          />
        </div>
      </Tooltip>
    )
  }
}

export default SmallPhoto
